import React from 'react';
import PropTypes from 'prop-types';
import InfoListItem from './components/InfoListItem';
import './styles.css';

const InfoList = props => {
  const listStyleObj = {
    ...props.listStyles,
  };

  const itemStyleObj = {
    ...props.itemStyles,
  };

  return (
    <ul className="info-list" style={listStyleObj}>
      {Object.entries(props.objectList).map((array, i) => (
        <InfoListItem
          href={array[1].href}
          name={array[1].title}
          value={array[1].value}
          key={i}
          styles={itemStyleObj}
        />
      ))}
    </ul>
  );
};

InfoList.propTypes = {
  listStyle: PropTypes.object,
  itemStyle: PropTypes.object,
  objectList: PropTypes.object,
};

export default InfoList;
